import { useCartContext } from "app/providers/CartProvider";
import { useOrderContext } from "app/providers/OrderProvider";
import { useNavigate } from "react-router";
import { api } from "shared/api";
import { STORAGE_PLAN_APPOINTMENT_LATER } from "shared/config";
import { useEffect } from "react";
import { useCreateBumbalDate } from "./useCreateBumbalDate";
import { toast } from "react-toastify";

export const useCheckoutSubmitBumbalDate = () => {
  const { refetchOrder } = useOrderContext();
  const { mutateBumbalDate, bumbalDateCreateStatus, isCreatingBumbalDate } =
    useCreateBumbalDate();
  const { order, type } = useOrderContext();
  const navigate = useNavigate();
  const { resetCart } = useCartContext();

  const submitBumbalDate = async (
    selectedDate: Date | null,
    planAppointmentLater: boolean,
  ) => {
    if (!selectedDate && !planAppointmentLater) return;

    if (planAppointmentLater) {
      if (!order || !order.id) {
        // TODO: show error
        return;
      }

      localStorage.setItem(STORAGE_PLAN_APPOINTMENT_LATER, "true");
      await api().gersSendBumbalMailMeasurement(order.id, "measurement");

      navigate(`../afspraak-status/?orderId=${order?.id || ""}`, {
        replace: true,
      });
      // resetCart();
      window.location.reload();
    } else if (selectedDate) {
      mutateBumbalDate(selectedDate);
    }
  };

  useEffect(() => {
    if (bumbalDateCreateStatus === "success") {
      navigate(`/afspraak-bedankt?type=${type}&reference=${order!.id}`, {
        replace: true,
      });
      window.location.reload();
      resetCart();
      refetchOrder();
    } else if (bumbalDateCreateStatus === "error") {
      toast.error("Er is iets fout gegaan met het maken van uw bumbaldate.");
    }
  }, [bumbalDateCreateStatus]);

  return {
    submitBumbalDate,
    isCreatingBumbalDate,
  };
};
